__turbopack_context__.v({
  "anchor-links": "gRivhG_anchor-links",
  "card": "gRivhG_card",
  "card-container": "gRivhG_card-container",
  "card-eyebrow": "gRivhG_card-eyebrow",
  "card-hook": "gRivhG_card-hook",
  "card-title": "gRivhG_card-title",
  "image-container": "gRivhG_image-container",
  "link-filter": "gRivhG_link-filter",
  "play-button": "gRivhG_play-button",
  "play-icon": "gRivhG_play-icon",
  "skeleton-list": "gRivhG_skeleton-list",
});
